import { Button } from "antd";
import React, { useEffect } from "react";

export default function Metrics({
  metricData,
  currentMetric,
  setCurrentMetric,
  setMetricType,
  metricVals,
  metricUnits,
}) {
  const setMetric = (metric, type) => {
    setCurrentMetric(metric);
    setMetricType(type);
  };

  const isDictionary = (variable) => {
    return (
      typeof variable === "object" &&
      variable !== null &&
      !Array.isArray(variable)
    );
  };
  const getMetricLabel = (metric) => {
    if (typeof metric === "string") {
      return metric;
    } else if (isDictionary(metric)) {
      return metric.label;
    }
    return "Unknown Metric";
  };

  const getMetricValue = (metric) => {
    if (typeof metric === "string") {
      return metric;
    } else if (isDictionary(metric)) {
      return metric.value;
    }
    return "Unknown Metric";
  };

  const matchMetricValue = (metric, currMetric) => {
    if (typeof metric === "string") {
      return metric === currMetric;
    } else if (isDictionary(metric)) {
      return metric.value === currMetric.value;
    } else {
      return false;
    }
  };

  return (
    <div
      className="flex flex-wrap justify-center mb-10 max-w-[40%] sm:max-w-full rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-101"
      id="metricButtons"
    >
      <p className="w-full text-center font-IBMPlexSansBold text-2xl mb-5 heading">
        Select Metric
      </p>
      {metricData?.map((metricGroup) =>
        metricGroup?.metrics?.map((metric) => (
          <Button
            key={`${getMetricValue(metric)}`}
            size="large"
            className={`mx-2 my-1 !h-fit w-[40%] sm:mx-1 rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-101 ${
              matchMetricValue(metric, currentMetric) ? "active" : ""
            }`}
            onClick={() => setMetric(metric, metricGroup.type)}
          >
            <div className="flex flex-col items-center overflow-hidden sm:overflow-scroll sm:break-words">
              <p className="text-xs font-IBMPlexSansBold font-bold w-full text-center">
                {getMetricLabel(metric)}
              </p>
              <p>
                ({metricVals ? metricVals[getMetricValue(metric)] : null}
                {metricUnits[getMetricValue(metric)] == ""
                  ? ""
                  : ` ${metricUnits[getMetricValue(metric)]}`}
                )
              </p>
            </div>
          </Button>
        )),
      )}
    </div>
  );
}
